/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Price_Per_Lb_LabelInputs */

const en_cargo_price_per_lb_label = /** @type {(inputs: Cargo_Price_Per_Lb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price/lb ($)`)
};

const es_cargo_price_per_lb_label = /** @type {(inputs: Cargo_Price_Per_Lb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio/lb ($)`)
};

/**
* | output |
* | --- |
* | "Price/lb ($)" |
*
* @param {Cargo_Price_Per_Lb_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_price_per_lb_label = /** @type {((inputs?: Cargo_Price_Per_Lb_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Price_Per_Lb_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_price_per_lb_label(inputs)
	return es_cargo_price_per_lb_label(inputs)
});